import { useCrowdfundingProvider } from '#Context/crowdfunding/Crowdfunding.provider.js';
import { StoreItem, useShowCampaignSettings } from '@givebacks/api/store';
import { AccordionCard, AddAdditionalFieldsForm, Divider, Textarea } from 'ui';
import { UseFormReturnType } from 'ui/Form';

import { AddEditTicketFormType } from './AddTicketForm.type';

const AdditionalSettings = ({
  options,
  form,
  isOpen = false,
}: {
  options?: StoreItem['options'];
  form: UseFormReturnType<AddEditTicketFormType>;
  isOpen: boolean;
}) => {
  const { campaignId, causeId } = useCrowdfundingProvider();
  const { data: campaignSettings } = useShowCampaignSettings({
    campaignId,
    causeId,
  });
  const { isCampaignReadOnly } = campaignSettings;

  return (
    <AccordionCard
      isCardCollapsed={!isOpen}
      title="Additional Settings"
      description="Add a ticket description and fields to collect during purchase."
    >
      <Textarea
        label={`Ticket Description`}
        placeholder={`Enter Ticket Description`}
        {...form.getInputProps('description')}
        autosize
        minRows={3}
        maxRows={3}
      />
      <Divider my={'lg'} />
      <AddAdditionalFieldsForm
        isDisabled={isCampaignReadOnly}
        options={options}
        isOrderable
        formId="options"
        title="Add Additional Ticket Fields"
      />
    </AccordionCard>
  );
};

export { AdditionalSettings };
